import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"




export const IllegalDailyComplaint = () => {

    const { t } = useTranslation()
    const navigate = useNavigate();

    return (

        <>
            <>
                <div className="col-12 col-lg-12 ps-lg-0  ">
                    <div className="row my-2">
                        <div className="col-12 bg-white rounded_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>
                            <div className="row">

                                <div className="col-12 col-md-12 pb-3 pt-2">
                                    <h6 className="fw-bold pt-2 text-center text-danger pb-0">{t('EncroachmentDashboard.DailyComplaint')}</h6>

                                    <div className="py-1 mt-1 border rounded_eic bg_daily_complaint_img" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                                        <div className="row text-center">

                                            <div className="col-12  border-end">
                                                <div className="row ">
                                                    <div className="col-12 ps-5 text-start cursor-pointer"
                                                        onClick={() => navigate('/TodaysTotalComplaintIllegalGrid')}
                                                    >
                                                        <h6 className="text-dark pt-1">{t('EncroachmentDashboard.TodaysTotalComplate')}</h6>
                                                        <h2 className="pt-0 fw-bold text-danger">21</h2>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <hr className="text-danger my-2" />

                                    <div className="py-1 mt-2 border rounded_eic bg_daily_complaint_img_new" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                                        <div className="row text-center">

                                            <div className="col-12  border-end">
                                                <div className="row ">
                                                    <div className="col-12  ps-5 text-start cursor-pointer"
                                                        onClick={() => navigate('/TodaysClosedComplaintIllegalGrid')}
                                                    >
                                                        <h6 className=" text-dark pt-1">{t('EncroachmentDashboard.TodaysClosedComplaint')}</h6>
                                                        <h2 className="pt-0 fw-bold text-danger">6</h2>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </>



        </>


    )
}